import { z } from 'zod'

export const ChangelogUserSchema = z.object({
  id: z.number(),
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  email: z.string(),
  phone: z.string().nullish()
})

export const ChangelogActionSchema = z.object({
  id: z.number(),
  description: z.string()
})
